/**
 * jQuery.marquee - scrolling text like old marquee element
 * @author Aamir Afridi - aamirafridi(at)gmail(dot)com / http://aamirafridi.com/jquery/jquery-marquee-plugin
 */;
 (function($) {
  $.fn.marquee = function(options) {
      return this.each(function() {
          // Extend the options if any provided
          var o = $.extend({}, $.fn.marquee.defaults, options),
              $this = $(this),
              $marqueeWrapper, containerWidth, animationCss, verticalDir, elWidth,
              loopCount = 3,
              playState = 'animation-play-state',
              css3AnimationIsSupported = false,

              // Private methods
              _prefixedEvent = function(element, type, callback) {
                  var pfx = ["webkit", "moz", "MS", "o", ""];
                  for (var p = 0; p < pfx.length; p++) {
                      if (!pfx[p]) type = type.toLowerCase();
                      element.addEventListener(pfx[p] + type, callback, false);
                  }
              },

              _objToString = function(obj) {
                  var tabjson = [];
                  for (var p in obj) {
                      if (obj.hasOwnProperty(p)) {
                          tabjson.push(p + ':' + obj[p]);
                      }
                  }
                  tabjson.push();
                  return '{' + tabjson.join(',') + '}';
              },

              _startAnimationWithDelay = function() {
                  $this.timer = setTimeout(animate, o.delayBeforeStart);
              },

              // Public methods
              methods = {
                  pause: function() {
                      if (css3AnimationIsSupported && o.allowCss3Support) {
                          $marqueeWrapper.css(playState, 'paused');
                      } else {
                          // pause using pause plugin
                          if ($.fn.pause) {
                              $marqueeWrapper.pause();
                          }
                      }
                      // save the status
                      $this.data('runningStatus', 'paused');
                      // fire event
                      $this.trigger('paused');
                  },

                  resume: function() {
                      // resume using css3
                      if (css3AnimationIsSupported && o.allowCss3Support) {
                          $marqueeWrapper.css(playState, 'running');
                      } else {
                          // resume using pause plugin
                          if ($.fn.resume) {
                              $marqueeWrapper.resume();
                          }
                      }
                      // save the status
                      $this.data('runningStatus', 'resumed');
                      // fire event
                      $this.trigger('resumed');
                  },

                  toggle: function() {
                      methods[$this.data('runningStatus') === 'resumed' ? 'pause' : 'resume']();
                  },

                  destroy: function() {
                      // Clear timer
                      clearTimeout($this.timer);
                      // Unbind all events
                      $this.find("*").addBack().off();
                      // Just unwrap the elements that has been added using this plugin
                      $this.html($this.find('.js-marquee:first').html());
                  }
              };

          // Check for methods
          if (typeof options === 'string') {
              if ($.isFunction(methods[options])) {
                  // Following two IF statements to support public methods
                  if (!$marqueeWrapper) {
                      $marqueeWrapper = $this.find('.js-marquee-wrapper');
                  }
                  if ($this.data('css3AnimationIsSupported') === true) {
                      css3AnimationIsSupported = true;
                  }
                  methods[options]();
              }
              return;
          }

          /* Check if element has data attributes. They have top priority
             For details https://twitter.com/aamirafridi/status/403848044069679104 - Can't find a better solution :/
             jQuery 1.3.2 doesn't support $.data().KEY hence writting the following */
          var dataAttributes = {},
          attr;
          $.each(o, function(key) {
              // Check if element has this data attribute
              attr = $this.attr('data-' + key);
              if (typeof attr !== 'undefined') {
                  // Now check if value is boolean or not
                  switch (attr) {
                      case 'true':
                          attr = true;
                          break;
                      case 'false':
                          attr = false;
                          break;
                  }
                  o[key] = attr;
              }
          });

          // Reintroduce speed as an option. It calculates duration as a factor of the container width
          // measured in pixels per second.
          if (o.speed) {
              o.duration = parseInt($this.width(), 10) / o.speed * 1000;
          }

          // Shortcut to see if direction is upward or downward
          verticalDir = o.direction === 'up' || o.direction === 'down';

          // no gap if not duplicated
          o.gap = o.duplicated ? parseInt(o.gap) : 0;

          // wrap inner content into a div
          $this.wrapInner('<div class="js-marquee"></div>');

          // Make copy of the element
          var $el = $this.find('.js-marquee').css({
              'margin-right': o.gap,
              'float': 'left'
          });

          if (o.duplicated) {
              var max = o.duplicated > 1 ? o.duplicated : 1;
              for (var i=0; i<max; i++) {
                  $el.clone(true).appendTo($this);
              }
          }

          // wrap both inner elements into one div
          $this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');

          // Save the reference of the wrapper
          $marqueeWrapper = $this.find('.js-marquee-wrapper');

          // If direction is up or down, get the height of main element
          if (verticalDir) {
              var containerHeight = $this.height();
              $marqueeWrapper.removeAttr('style');
              $this.height(containerHeight);

              // Change the CSS for js-marquee element
              $this.find('.js-marquee').css({
                  'float': 'none',
                  'margin-bottom': o.gap,
                  'margin-right': 0
              });

              // Remove bottom margin from 2nd element if duplicated
              if (o.duplicated) {
      $this.find('.js-marquee:last').css({
    'margin-bottom': 0
      });
  }

              var elHeight = $this.find('.js-marquee:first').height() + o.gap;

              // adjust the animation duration according to the text length
              if (o.startVisible && !o.duplicated) {
                  // Compute the complete animation duration and save it for later reference
                  // formula is to: (Height of the text node + height of the main container / Height of the main container) * duration;
                  o._completeDuration = ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10)) * o.duration;

                  // formula is to: (Height of the text node / height of the main container) * duration
                  o.duration = (parseInt(elHeight, 10) / parseInt(containerHeight, 10)) * o.duration;
              } else {
                  // formula is to: (Height of the text node + height of the main container / Height of the main container) * duration;
                  o.duration = ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) / parseInt(containerHeight, 10)) * o.duration;
              }

          } else {
              // Save the width of the each element so we can use it in animation
              elWidth = $this.find('.js-marquee:first').width() + o.gap;

              // container width
              containerWidth = $this.width();

              // adjust the animation duration according to the text length
              if (o.startVisible && !o.duplicated) {
                  // Compute the complete animation duration and save it for later reference
                  // formula is to: (Width of the text node + width of the main container / Width of the main container) * duration;
                  o._completeDuration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration;

                  // (Width of the text node / width of the main container) * duration
                  o.duration = (parseInt(elWidth, 10) / parseInt(containerWidth, 10)) * o.duration;
              } else {
                  // formula is to: (Width of the text node + width of the main container / Width of the main container) * duration;
                  o.duration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration;
              }
          }

          // if duplicated then reduce the duration
          if (o.duplicated) {
              o.duration = o.duration / 2;
          }

          if (o.allowCss3Support) {
              var elm = document.body || document.createElement('div'),
                  animationName = 'marqueeAnimation-' + Math.floor(Math.random() * 10000000),
                  domPrefixes = 'Webkit Moz O ms Khtml'.split(' '),
                  animationString = 'animation',
                  animationCss3Str = '',
                  keyframeString = '';

              // Check css3 support
              if (elm.style.animation !== undefined) {
                  keyframeString = '@keyframes ' + animationName + ' ';
                  css3AnimationIsSupported = true;
              }

              if (css3AnimationIsSupported === false) {
                  for (var i = 0; i < domPrefixes.length; i++) {
                      if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                          var prefix = '-' + domPrefixes[i].toLowerCase() + '-';
                          animationString = prefix + animationString;
                          playState = prefix + playState;
                          keyframeString = '@' + prefix + 'keyframes ' + animationName + ' ';
                          css3AnimationIsSupported = true;
                          break;
                      }
                  }
              }

              if (css3AnimationIsSupported) {
                  animationCss3Str = animationName + ' ' + o.duration / 1000 + 's ' + o.delayBeforeStart / 1000 + 's infinite ' + o.css3easing;
                  $this.data('css3AnimationIsSupported', true);
              }
          }

          var _rePositionVertically = function() {
              $marqueeWrapper.css('transform', 'translateY(' + (o.direction === 'up' ? containerHeight + 'px' : '-' + elHeight + 'px') + ')');
          },
          _rePositionHorizontally = function() {
              $marqueeWrapper.css('transform', 'translateX(' + (o.direction === 'left' ? containerWidth + 'px' : '-' + elWidth + 'px') + ')');
          };

          // if duplicated option is set to true than position the wrapper
          if (o.duplicated) {
              if (verticalDir) {
                  if (o.startVisible) {
                      $marqueeWrapper.css('transform', 'translateY(0)');
                  } else {
                      $marqueeWrapper.css('transform', 'translateY(' + (o.direction === 'up' ? containerHeight + 'px' : '-' + ((elHeight * 2) - o.gap) + 'px') + ')');
                  }
              } else {
                  if (o.startVisible) {
                      $marqueeWrapper.css('transform', 'translateX(0)');
                  } else {
                      $marqueeWrapper.css('transform', 'translateX(' + (o.direction === 'left' ? containerWidth + 'px' : '-' + ((elWidth * 2) - o.gap) + 'px') + ')');
                  }
              }

              // If the text starts out visible we can skip the two initial loops
              if (!o.startVisible) {
                loopCount = 1;
              }
          } else if (o.startVisible) {
              // We only have two different loops if marquee is duplicated and starts visible
              loopCount = 2;
          } else {
              if (verticalDir) {
                  _rePositionVertically();
              } else {
                  _rePositionHorizontally();
              }
          }

          // Animate recursive method
          var animate = function() {
              if (o.duplicated) {
                  // When duplicated, the first loop will be scroll longer so double the duration
                  if (loopCount === 1) {
                      o._originalDuration = o.duration;
                      if (verticalDir) {
                          o.duration = o.direction === 'up' ? o.duration + (containerHeight / ((elHeight) / o.duration)) : o.duration * 2;
                      } else {
                          o.duration = o.direction === 'left' ? o.duration + (containerWidth / ((elWidth) / o.duration)) : o.duration * 2;
                      }
                      // Adjust the css3 animation as well
                      if (animationCss3Str) {
                          animationCss3Str = animationName + ' ' + o.duration / 1000 + 's ' + o.delayBeforeStart / 1000 + 's ' + o.css3easing;
                      }
                      loopCount++;
                  }
                  // On 2nd loop things back to normal, normal duration for the rest of animations
                  else if (loopCount === 2) {
                      o.duration = o._originalDuration;
                      // Adjust the css3 animation as well
                      if (animationCss3Str) {
                          animationName = animationName + '0';
                          keyframeString = $.trim(keyframeString) + '0 ';
                          animationCss3Str = animationName + ' ' + o.duration / 1000 + 's 0s infinite ' + o.css3easing;
                      }
                      loopCount++;
                  }
              }

              if (verticalDir) {
                  if (o.duplicated) {

                      // Adjust the starting point of animation only when first loops finishes
                      if (loopCount > 2) {
                          $marqueeWrapper.css('transform', 'translateY(' + (o.direction === 'up' ? 0 : '-' + elHeight + 'px') + ')');
                      }

                      animationCss = {
                          'transform': 'translateY(' + (o.direction === 'up' ? '-' + elHeight + 'px' : 0) + ')'
                      };
                  } else if (o.startVisible) {
                      // This loop moves the marquee out of the container
                      if (loopCount === 2) {
                          // Adjust the css3 animation as well
                          if (animationCss3Str) {
                              animationCss3Str = animationName + ' ' + o.duration / 1000 + 's ' + o.delayBeforeStart / 1000 + 's ' + o.css3easing;
                          }
                          animationCss = {
                              'transform': 'translateY(' + (o.direction === 'up' ? '-' + elHeight + 'px' : containerHeight + 'px') + ')'
                          };
                          loopCount++;
                      } else if (loopCount === 3) {
                          // Set the duration for the animation that will run forever
                          o.duration = o._completeDuration;
                          // Adjust the css3 animation as well
                          if (animationCss3Str) {
                                  animationName = animationName + '0';
                                  keyframeString = $.trim(keyframeString) + '0 ';
                                  animationCss3Str = animationName + ' ' + o.duration / 1000 + 's 0s infinite ' + o.css3easing;
                          }
                          _rePositionVertically();
                      }
                  } else {
                      _rePositionVertically();
                      animationCss = {
                          'transform': 'translateY(' + (o.direction === 'up' ? '-' + ($marqueeWrapper.height()) + 'px' : containerHeight + 'px') + ')'
                      };
                  }
              } else {
                  if (o.duplicated) {

                      // Adjust the starting point of animation only when first loops finishes
                      if (loopCount > 2) {
                          $marqueeWrapper.css('transform', 'translateX(' + (o.direction === 'left' ? 0 : '-' + elWidth + 'px') + ')');
                      }

                      animationCss = {
                          'transform': 'translateX(' + (o.direction === 'left' ? '-' + elWidth + 'px' : 0) + ')'
                      };

                  } else if (o.startVisible) {
                      // This loop moves the marquee out of the container
                      if (loopCount === 2) {
                          // Adjust the css3 animation as well
                          if (animationCss3Str) {
                              animationCss3Str = animationName + ' ' + o.duration / 1000 + 's ' + o.delayBeforeStart / 1000 + 's ' + o.css3easing;
                          }
                          animationCss = {
                              'transform': 'translateX(' + (o.direction === 'left' ? '-' + elWidth + 'px' : containerWidth + 'px') + ')'
                          };
                          loopCount++;
                      } else if (loopCount === 3) {
                          // Set the duration for the animation that will run forever
                          o.duration = o._completeDuration;
                          // Adjust the css3 animation as well
                          if (animationCss3Str) {
                              animationName = animationName + '0';
                              keyframeString = $.trim(keyframeString) + '0 ';
                              animationCss3Str = animationName + ' ' + o.duration / 1000 + 's 0s infinite ' + o.css3easing;
                          }
                          _rePositionHorizontally();
                      }
                  } else {
                      _rePositionHorizontally();
                      animationCss = {
                          'transform': 'translateX(' + (o.direction === 'left' ? '-' + elWidth + 'px' : containerWidth + 'px') + ')'
                      };
                  }
              }

              // fire event
              $this.trigger('beforeStarting');

              // If css3 support is available than do it with css3, otherwise use jQuery as fallback
              if (css3AnimationIsSupported) {
                  // Add css3 animation to the element
                  $marqueeWrapper.css(animationString, animationCss3Str);
                  var keyframeCss = keyframeString + ' { 100%  ' + _objToString(animationCss) + '}',
                       $styles = $marqueeWrapper.find('style');

                  // Now add the keyframe animation to the marquee element
                  if ($styles.length !== 0) {
                      // Bug fixed for jQuery 1.3.x - Instead of using .last(), use following
                      $styles.filter(":last").html(keyframeCss);
                  } else {
                      $('head').append('<style>' + keyframeCss + '</style>');
                  }

                  // Animation iteration event
                  _prefixedEvent($marqueeWrapper[0], "AnimationIteration", function() {
                      $this.trigger('finished');
                  });
                  // Animation stopped
                  _prefixedEvent($marqueeWrapper[0], "AnimationEnd", function() {
                      animate();
                      $this.trigger('finished');
                  });

              } else {
                  // Start animating
                  $marqueeWrapper.animate(animationCss, o.duration, o.easing, function() {
                      // fire event
                      $this.trigger('finished');
                      // animate again
                      if (o.pauseOnCycle) {
                          _startAnimationWithDelay();
                      } else {
                          animate();
                      }
                  });
              }
              // save the status
              $this.data('runningStatus', 'resumed');
          };

          // bind pause and resume events
          $this.on('pause', methods.pause);
          $this.on('resume', methods.resume);

          if (o.pauseOnHover) {
              $this.on('mouseenter', methods.pause);
              $this.on('mouseleave', methods.resume);
          }

          // If css3 animation is supported than call animate method at once
          if (css3AnimationIsSupported && o.allowCss3Support) {
              animate();
          } else {
              // Starts the recursive method
              _startAnimationWithDelay();
          }

      });
  }; // End of Plugin
  // Public: plugin defaults options
  $.fn.marquee.defaults = {
      // If you wish to always animate using jQuery
      allowCss3Support: true,
      // works when allowCss3Support is set to true - for full list see http://www.w3.org/TR/2013/WD-css3-transitions-20131119/#transition-timing-function
      css3easing: 'linear',
      // requires jQuery easing plugin. Default is 'linear'
      easing: 'linear',
      // pause time before the next animation turn in milliseconds
      delayBeforeStart: 1000,
      // 'left', 'right', 'up' or 'down'
      direction: 'left',
      // true or false - should the marquee be duplicated to show an effect of continues flow
      duplicated: false,
      // duration in milliseconds of the marquee in milliseconds
      duration: 5000,
      // Speed allows you to set a relatively constant marquee speed regardless of the width of the containing element. Speed is measured in pixels per second.
      speed: 0,
      // gap in pixels between the tickers
      gap: 20,
      // on cycle pause the marquee
      pauseOnCycle: false,
      // on hover pause the marquee - using jQuery plugin https://github.com/tobia/Pause
      pauseOnHover: false,
      // the marquee is visible initially positioned next to the border towards it will be moving
      startVisible: false
  };
})(jQuery);
(() => {
  // JS translation
  const translationLabels = {
    'next': {
      'de': 'Weiter',
      'en': 'Next',
    },
    'previous': {
      'de': 'Zurück',
      'en': 'Previous',
    }
  };

  window.getCurrentPageLanguage = () => {
    return (document.querySelector('html')?.getAttribute('lang') || 'de').toLowerCase();
  }

  window.getTranslation = (key) => {
    return translationLabels?.[key]?.[window.getCurrentPageLanguage()] || key;
  }
})();

(function () {
  $(function () {
    objectFitImages();
  });
})();

// destroy inView Objects
function destroyInViewOnContentDestroy(inViewObject) {
  $(document).on('destroy-content', function () {
    inViewObject.handlers.enter = [];
    inViewObject.handlers.exit = [];
    inViewObject.current = [];
    inViewObject.elements = [];
  });
}

(function() {

    $(document).ready(function() {

        // var inviewSelectorDefault = '.u-section:not(.u-quote__text, .u-quote__name, .u-quote__title';

        // var inviewDefault = inView(inviewSelectorDefault).on('enter', function(target) {

        //     var $target = $(target),
        //         height = $target.outerHeight(),
        //         lineHeight = parseFloat($target.css('line-height'));

        //     if($target.hasClass('u-inview-complete')) return;

        //     var animation = anime.timeline({
        //         easing: 'easeOutExpo',
        //         begin: function() {
        //             $target.addClass('u-inview-complete');
        //             $target.css({
        //                 'height': height,
        //                 'overflow': 'hidden'
        //             });
        //         },
        //         complete: function() {
        //             $target.css('line-height', '');
        //             $target.css({
        //                 'height': '',
        //                 'overflow': ''
        //             });
        //         }
        //     }).
        //     add({
        //         targets: target,
        //         translateY: ["100%",0],
        //         opacity: [0,1],
        //         // lineHeight: [ lineHeight * 20 + 'px', lineHeight + 'px' ]
        //     });

        // });
        // destroyInViewOnContentDestroy(inviewDefault);
        // $(inviewSelectorDefault).css({
        //     'opacity': 0
        // });

        // var inviewSelectorPictureLeft = '.u-section__content-left .u-picture img';
        // var inviewPictureLeft = inView(inviewSelectorPictureLeft).on('enter', function(target) {
        //     var $target = $(target);

        //     if($target.hasClass('u-inview-complete')) return;

        //     anime.timeline({
        //         easing: 'easeOutExpo',
        //         begin: function() {
        //             $target.addClass('u-inview-complete');
        //         }
        //     }).
        //     add({
        //         targets: target,
        //         translateX: ["-100%",0],
        //         opacity: [0,1]
        //     });
        // });
        // destroyInViewOnContentDestroy(inviewPictureLeft);
        // $(inviewSelectorPictureLeft).css({
        //     'transform': 'translateX(-100%)'
        // });
        // $(inviewSelectorPictureLeft).parent().css({
        //     'overflow': 'hidden'
        // });

        // var inviewSelectorPictureLeft = '.u-section__content-right .u-picture img';
        // var inviewPictureLeft = inView(inviewSelectorPictureLeft).on('enter', function(target) {
        //     var $target = $(target);

        //     if($target.hasClass('u-inview-complete')) return;

        //     anime.timeline({
        //         easing: 'easeOutExpo',
        //         begin: function() {
        //             $target.addClass('u-inview-complete');
        //         }
        //     }).
        //     add({
        //         targets: target,
        //         translateX: ["100%",0],
        //         opacity: [0,1]
        //     });
        // });
        // destroyInViewOnContentDestroy(inviewPictureLeft);
        // $(inviewSelectorPictureLeft).css({
        //     'transform': 'translateX(100%)'
        // });
        // $(inviewSelectorPictureLeft).parent().css({
        //     'overflow': 'hidden'
        // });

        // var inviewSelectorPicture = '.u-section__content:not(.u-section__content-left):not(.u-section__content-right) > figure.u-picture img',
        //     directionToLeft = false;

        // var inviewPicture = inView(inviewSelectorPicture).on('enter', function(target) {
        //     var $target = $(target);

        //     directionToLeft = !directionToLeft;

        //     if($target.hasClass('u-inview-complete')) return;

        //     anime.timeline({
        //         easing: 'easeOutExpo',
        //         begin: function() {
        //             $target.addClass('u-inview-complete');
        //             $target.css({
        //                 'transform': directionToLeft ? 'translateX(100%)' : 'translateX(-100%)'
        //             });
        //         }
        //     }).
        //     add({
        //         targets: target,
        //         translateX: [directionToLeft ? '100%' : '-100%', 0],
        //         opacity: [0,1]
        //     });
        // });
        // destroyInViewOnContentDestroy(inviewPicture);
        // $(inviewSelectorPicture).css({
        //     'opacity': 0
        // });
        // $(inviewSelectorPicture).parent().css({
        //     'overflow': 'hidden'
        // });

    });

})();
(function() {

  function CustomCursor($element, options) {
    var that = this;

      this.$element = $element;
      this.$cursor = null;
      this.movingTimer = null;
      this.options = $.extend({}, {
        $container: null
      }, options);

      this.$middleFinger = null;
      this.$ringFinger = null;
      this.$littleFinger = null;
      this.$pointerFinger = null;
      this.$thumb = null;

      this.animations = {};

      this.paths = {
        middleFinger: {
          full: 'M69,42V9c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6v33',
          small: 'M69,42V32c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6v10'
        },
        ringFinger: {
          full: 'M81,43V14c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6v29',
          small: 'M81,43V36c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6v7'
        },
        littleFinger: {
          full: 'M93,43V23c0-3.3,2.6-6,6-6c3.3,0,6,2.7,6,6v26',
          small: 'M93,43V40c0-3.3,2.6-6,6-6c3.3,0,6,2.7,6,6v9'
        },
        pointerFinger: {
          full: 'M57,49V15c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6V43',
          half: 'M57,49V23c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6V43',
          small: 'M57,49V36c0-3.3,2.6-6,6-6l0,0c3.3,0,6,2.7,6,6V43'
        },
        thumb: {
          full:  'M105,48v19c0,14.8-14.3,25.3-29,24c-6.3-0.6-12.6-3.5-17-8L38,61c-2.4-2.4-2.4-6.6,0-9 l0,0c2.4-2.4,6.6-2.4,9,0 l10,10V46',
          small: 'M105,48v19c0,14.8-14.3,25.3-29,24c-6.3-0.6-12.6-3.5-17-8L45,68c-2.4-2.4-2.4-6.6,0-9 l0,0c2.4-2.4,6.6-2.4,9,0 l3,3V46'
        }
      }

      this.$container = this.options.$container || this.$element;
      
      this.init();
  }

  CustomCursor.prototype.init = function() {
    var that = this;
    
    this.$container.find('.' + this.options.cssClass).remove();
    this.$cursor = $(
      '<svg class="u-custom-cursor" version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 151.8 97" style="enable-background:new 0 0 151.8 97;" xml:space="preserve">'
      + '<path class="st0	u-custom-cursor__finger u-custom-cursor__middle-finger" d="' + this.paths.middleFinger.full + '"/>'
      + '<path class="st1 u-custom-cursor__finger u-custom-cursor__ring-finger" d="' + this.paths.ringFinger.full + '"/>'
      + '<path class="st1 u-custom-cursor__finger u-custom-cursor__little-finger" d="' + this.paths.littleFinger.full + '"/>'
      + '<path class="st1 u-custom-cursor__finger u-custom-cursor__pointer-finger" d="' + this.paths.pointerFinger.full + '"/>'
      + '<path class="st2 u-custom-cursor__finger u-custom-cursor__thumb" d="' + this.paths.thumb.full + '"/>'
      + '<polyline class="u-custom-cursor__arrow" points="15,39 4,50 15,61 "/>'
      + '<polyline class="u-custom-cursor__arrow" points="137,61 148,50 137,39 "/>'
      + '</svg>'
    );
    this.$container.append(this.$cursor);

    this.$middleFinger = this.$cursor.find('.u-custom-cursor__middle-finger');
    this.$ringFinger = this.$cursor.find('.u-custom-cursor__ring-finger');
    this.$littleFinger = this.$cursor.find('.u-custom-cursor__little-finger');
    this.$pointerFinger = this.$cursor.find('.u-custom-cursor__pointer-finger');
    this.$thumb = this.$cursor.find('.u-custom-cursor__thumb');

    this.$container.on('mousemove', function(e) {
      that.mousemove(e);
    });

    this.$container.addClass('u-custom-cursor__container');



    this.$container.on('mouseenter', 'button, a', function() {
      that.hover(true);
    });
    
    this.$container.on('mouseleave', 'button, a', function() {
      that.hover(false);
    });

    this.$container.on('mousedown', 'button, a', function() {
      that.click(true);
    });
    
    this.$container.on('mouseup', 'button, a', function() {
      that.click(false);
    });

    this.$container.on('mousedown', function(e) {
      that.grab(true, e);
    });
    
    this.$container.on('mouseup', function(e) {
      that.grab(false, e);
    });
  }

  CustomCursor.prototype.mousemove = function(e) {
    var that = this,
        offset = this.$container.offset();

    this.$cursor.addClass('is-moving');

    this.$cursor.css('transform', 'translate(calc(' + (e.pageX - offset.left) + 'px - 40%), calc(' + (e.pageY - offset.top) + 'px - 20%))');
    this.$cursor.css('transform', 'translateX(' + (e.pageX - offset.left) + 'px) translateX(-40%) translateY(' + (e.pageY - offset.top) + 'px) translateY(-20%)');
  
    clearTimeout(this.movingTimer);
  
    this.movingTimer = setTimeout(function() {
      that.$cursor.removeClass('is-moving');
     }, 300);
  }

  CustomCursor.prototype.hover = function(isMouseOver) {
    var that = this;

    anime.timeline({
      easing: 'linear'
    })
    .add({
        targets: that.$littleFinger[0],
        duration: 200,
        d: isMouseOver ? that.paths.littleFinger.small : that.paths.littleFinger.full
    })
    .add({
        targets: that.$ringFinger[0],
        duration: 200,
        offset: '-=200',
        d: isMouseOver ? that.paths.ringFinger.small : that.paths.ringFinger.full
    })
    .add({
        targets: that.$middleFinger[0],
        duration: 200,
        offset: '-=200',
        d: isMouseOver ? that.paths.middleFinger.small : that.paths.middleFinger.full
    })
    .add({
      targets: that.$pointerFinger[0],
      duration: 200,
      d: that.paths.pointerFinger.full
    });
  }

  CustomCursor.prototype.click = function(isMouseDown) {
    var that = this;

    anime.timeline({
      easing: 'linear'
    })
    .add({
        targets: that.$pointerFinger[0],
        duration: 200,
        d: isMouseDown ? that.paths.pointerFinger.half : that.paths.pointerFinger.full
    });
  }

  CustomCursor.prototype.grab = function(isMouseDown, e) {

    if(!this.options.forceGrabbing) return;

    var that = this;

    anime.timeline({
      easing: 'linear'
    })
    .add({
        targets: that.$littleFinger[0],
        duration: 200,
        d: isMouseDown ? that.paths.littleFinger.small : that.paths.littleFinger.full
    })
    .add({
        targets: that.$ringFinger[0],
        duration: 200,
        offset: '-=200',
        d: isMouseDown ? that.paths.ringFinger.small : that.paths.ringFinger.full
    })
    .add({
        targets: that.$middleFinger[0],
        duration: 200,
        offset: '-=200',
        d: isMouseDown ? that.paths.middleFinger.small : that.paths.middleFinger.full
    })
    .add({
      targets: that.$pointerFinger[0],
      duration: 200,
      offset: '-=200',
      d: isMouseDown ? that.paths.pointerFinger.small : that.paths.pointerFinger.full
    })
    .add({
      targets: that.$thumb[0],
      duration: 200,
      offset: '-=200',
      d: isMouseDown ? that.paths.thumb.small : that.paths.thumb.full
    });
  }

  $.fn.generateCustomCursor = function(options) {
    var $element = $(this);

    if(!$element.data('custom-cursor')) {
      var customCursorObject = new CustomCursor($element, options);
      $element.data('custom-cursor', customCursorObject);
    }
  };

})();
(function () {

  var durations = {
    labelHide: 200,
    linkShow: 150
  };

  function ShareButton($element, options) {
    this.$element = $element;
    this.$toggler = this.$element.find('.u-share-button__toggler');
    this.$shareLinks = this.$element.find('.u-share-button__link');
    this.options = $.extend({}, {

    }, options);

    this.init();
  }

  ShareButton.prototype.isMobile = function() {
    const check = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));
    return !!check;
  }

  ShareButton.prototype.init = function () {

    var that = this;

    this.$toggler.on('click', function (e) {
      if (navigator.share && that.isMobile()) {
        navigator.share({
            title: that.$element.data('subject'),
            text: that.$element.data('text'),
            url: that.$element.data('url'),
          })
          .then(function () {
            console.log('Successful share')
          }).catch(function (error) {
            console.log('Error sharing', error)
          });
      } else {
        that.openShareLinks($(e.currentTarget));
      }
    });
  }

  ShareButton.prototype.openShareLinks = function () {

    var that = this;

    var animation = anime.timeline({
        easing: 'linear',
        begin: function () {
          that.$shareLinks.show();
          that.$element.css({
            'min-width': that.$toggler.outerWidth() + 2, // + border
            'min-height': that.$toggler.outerHeight() + 2, // + border
            'position': 'relative'
          });
          that.$toggler.css('position', 'absolute');

          that.$element.addClass('is-open')
        }
      })
      .add({
        targets: this.$toggler[0],
        duration: durations.labelHide,
        opacity: [1, 0],
        complete: function () {
          that.$toggler.hide();
        }
      }).add({
        targets: this.$element[0],
        duration: durations.linkShow,
        paddingLeft: [0, '1rem'],
        paddingRight: [0, '1rem']
      });

    for (var i = 0; i < this.$shareLinks.length; i++) {
      animation.add({
          targets: this.$shareLinks[i],
          duration: durations.linkShow,
          offset: '-=' + durations.linkShow,
          paddingLeft: [0, '1rem'],
          paddingRight: [0, '1rem']
        })
        .add({
          targets: this.$shareLinks[i],
          duration: durations.linkShow,
          opacity: [0, 1]
        })
    }
  }

  $(document).ready(function () {

    $('.u-share-button').each(function (index, element) {
      var $element = $(element);
      if (!$element.data('share-button')) {
        var shareButtonObject = new ShareButton($element);
        $element.data('share-button', shareButtonObject);
      }
    });

    $(document).on('click', '.u-share-button__link--pdf', function () {
      window.print()
    })
  });

})();
(function() {

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  anime.easings['inOutQuad'] = function(t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t };

  function Cards(element, options) {
      this.$element = $(element);
      this.slick = null;
      this.options = $.extend({}, {
        sliderOptions: {
          infinite: false,
          arrows: false,
          autoplay: false,
          variableWidth: true,
          adaptiveHeight: false
        }
      }, options);

      this.init();
  }

  Cards.prototype.init = function() {

    var that = this;

    this.slick = this.$element.slick(this.options.sliderOptions)
    .on("setPosition", function (event, slick) {

        // fix empty space after

        var $lastSlide = slick.$slides.last(),
            childPos = $lastSlide.offset(),
            parentPos = $lastSlide.parent().offset(),
            sliderWidth = slick.$slideTrack.parent().width(),
            trackTransform = parseInt(slick.$slideTrack.css("transform").split(",")[4], 10),
            childOffset = {
                top: childPos.top - parentPos.top,
                left: childPos.left - parentPos.left
            },
            minValue = sliderWidth - childOffset.left - $lastSlide.width() + 0;

            if (trackTransform < minValue) {
                slick.$slideTrack.css({
                    "transform": "translate3d(" + minValue +"px, 0, 0)",
                    "transition": "transform .5s"
                });
                slick.currentSlide = slick.currentSlide - 1;
            } 

    })
    .on('wheel', (function(e) {
      if ( e.originalEvent.deltaX !== 0 ) {
          e.preventDefault();
          if (e.originalEvent.deltaX >= 10) {
            $(this).slick('slickNext');
          } 
          if (e.originalEvent.deltaX <= -10) {
            $(this).slick('slickPrev');
          }
      }
    }));

    this.$element.on('click', '.u-cards__card', function(e) {
      var $card = $(e.target).closest('.u-cards__card');
      that.goTo($card);
      that.flipCard($card);
    });
  }

  Cards.prototype.goTo = function(card) {
    var $card = $(card);

    if($card.offset().left < 0 || ($(window).width() - $card.offset().left - $card.outerWidth()) < 0) {
      this.$element.slick('slickGoTo', $card.closest('.slick-slide').index());
    }
  }

  Cards.prototype.flipCard = function(card) {
    var $card = $(card),
        showBack = !$card.hasClass('is-flipped');

    $card.toggleClass('is-flipped');

    anime.timeline({
      easing: 'inOutQuad'
    })
    .add({
      targets: $card[0],
      duration: 600,
      translateX: showBack ? ["0%", "-100%"] : ["-100%", "0%"],
      rotateY: showBack ? ["0deg", "-180deg"] : ["-180deg", "0deg"]
    })
    .add({
      targets: $card.find('.u-cards__front')[0],
      duration: 600,
      offset: '-=600',
      opacity: !isIE11 ? [1, 1] : (showBack ? [1, 0] : [0, 1])
    })
    .add({
      targets: $card.find('.u-cards__back')[0],
      duration: 600,
      offset: '-=600',
      opacity: !isIE11 ? [1, 1] : (showBack ? [0, 1] : [1, 0])
    });
  };

  $(document).ready(function() {

      $('.u-cards').each(function(index, element) {
          $element = $(element);
          if(!$element.data('card')) {
              var cardObject = new Cards($element);
              $element.data('card', cardObject);
          }
      });

  });

})();
(function () {

  function CategoryTeaserSlider(element, options) {
      this.$element = $(element);
      this.slick = null;
      this.sliderOptions = $.extend({}, {
        infinite: false,
        arrows: true,
        autoplay: false,
        variableWidth: true,
        adaptiveHeight: false,
        appendArrows: this.$element.closest('.u-category-teaser-list__slider-wrapper').find('.u-category-teaser-list__arrows'),
        prevArrow: `<button class="u-category-teaser-list__prev" title="${getTranslation('previous')}" aria-label="${getTranslation('previous')}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 62"><circle cx="31" cy="31" r="30"/><path d="M35,37.23,33.28,39,26,31.5,33.28,24,35,25.77,29.41,31.5Z" style="fill:currentColor"/></svg></button>`,
        nextArrow: `<button class="u-category-teaser-list__next" title="${getTranslation('next')}" aria-label="${getTranslation('next')}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 62"><circle cx="31" cy="31" r="30"/><path d="M27,37.23,28.72,39,36,31.5,28.72,24,27,25.77l5.59,5.73Z" style="fill:currentColor"/></svg></button>`
      }, options);

      this.init();
  }

  CategoryTeaserSlider.prototype.init = function () {
    var that = this;

    this.slick = this.$element.slick(this.sliderOptions)
      .on("setPosition", function (event, slick) {

        // fix empty space after

        var $firstSlide = slick.$slides.first(),
            $lastSlide = slick.$slides.last(),
            firstChildPos = $firstSlide.offset(),
            childPos = $lastSlide.offset(),
            parentPos = $lastSlide.parent().offset(),
            sliderWidth = slick.$slideTrack.parent().width(),
            sliderCalculatedItemsWidth = childPos.left - firstChildPos.left + $lastSlide.width(),
            trackTransform = parseInt(slick.$slideTrack.css("transform").split(",")[4], 10),
            childOffset = {
                top: childPos.top - parentPos.top,
                left: childPos.left - parentPos.left
            },
            minValue = sliderWidth - childOffset.left - $lastSlide.width() + 0;

        if (trackTransform < minValue) {
          slick.$slideTrack.css({
            "transform": "translate3d(" + (sliderWidth > sliderCalculatedItemsWidth ? 0 : minValue) +"px, 0, 0)",
            "transition": "transform .5s"
          });
          slick.currentSlide = slick.currentSlide - 1;
        }
      })
      .on('wheel', (function(e) {
        if ( e.originalEvent.deltaX !== 0 ) {
            e.preventDefault();
            if (e.originalEvent.deltaX >= 10) {
              $(this).slick('slickNext');
            } 
            if (e.originalEvent.deltaX <= -10) {
              $(this).slick('slickPrev');
            }
        }
      }));

    this.$element.on('click', '.u-image-slider__item', function(e) {
      var $sliderItem = $(e.target).closest('.u-image-slider__item');
      that.goTo($sliderItem);
    });

    this.$element.data('slider', this);
  }

  CategoryTeaserSlider.prototype.goTo = function(sliderItem) {
    var $sliderItem = $(sliderItem);

    if($sliderItem.offset().left < 0 || ($(window).width() - $sliderItem.offset().left - $sliderItem.outerWidth()) < 0) {
      this.$element.slick('slickGoTo', $sliderItem.closest('.slick-slide').index());
    }
  }

  $(document).ready(function() {

    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
    document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
    $(window).resize(function() {
      setTimeout(function() {
        document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
      })
    });

      $('.u-category-teaser-list__slider').each(function() {
        new CategoryTeaserSlider(this);
      })
  });

})();
(function() {

    $(document).ready(function(e, currentSlide) {

        var $slideItem = $(currentSlide).closest('.slick-slide').next(':not(.slick-cloned)');
        
        if($slideItem.length <= 0) {
            $slideItem = $(currentSlide).closest('.slick-track').children(':not(.slick-cloned)').eq(0);
        }

        var $slideHeadline = $slideItem.find('.u-teaser__headline'),
            $slidePicture = $slideItem.find('.u-teaser__image'),
            
            $nextTopicTeaser = $('.u-footer__next-topic-teaser');

            if($slideHeadline.html()) {
                
                $nextTopicTeaser.find('.u-footer__next-topic-headline').html($slideHeadline.html().replace(/\s*(<br \/>|<br\/>|<br>)\s*/, " "));
                $nextTopicTeaser.find('.u-footer__next-topic-image').html($slidePicture.html());
                $nextTopicTeaser.attr('href', $slideItem.find('.u-main-slider__item').data('page-url'));
                
                $nextTopicTeaser.show();
                
            }
    });

    inView('.u-footer__next-topic-teaser, .u-epaper-teaser .u-section__inner').on('enter', function(target) {
        var $target = $(target);

        if($target.hasClass('u-inview-complete')) return;

        anime.timeline({
            easing: 'linear',
            begin: function() {
                $target.addClass('u-inview-complete');
            }
        }).
        add({
            targets: target,
            // translateY: ['100%', 0],
            opacity: [0,1]
        });
    });
    $('.u-footer__next-topic-teaser, .u-epaper-teaser .u-section__inner').css({
        'opacity': 0
    });

})();
(function () {

    var $header = $('.u-header'),
        openClass = 'is-open',
        burgerIconLineSelector = '.u-menu-toggler__burger-icon-line',
        closeIconLineSelector = '.u-menu-toggler__close-icon-line',
        mainMenuSelector = '.u-main-menu',
        $mainMenu = $(mainMenuSelector),
        pageJumpedToModuleOnLoad = false;

    function resizeMenu() {
        var $body = $('body');
        var $logoWrapper = $('.u-header__logo-wrapper');
        var $menuDesktop = $('.u-header__menu-desktop');
        var categoryWidth = $('.u-header__category').innerWidth() || 0;
        var freeSpace = categoryWidth > 0 ? 80 : 40;

        $menuDesktop.css({ 
            'position': 'fixed',
            'top': 0,
            'right': 0
        });

        $body.toggleClass('u-body--desktop-menu-mode', true);
        $body.toggleClass('u-body--mobile-menu-mode', false);

        var desktopMode = ($logoWrapper.offset().left + $logoWrapper.innerWidth() + categoryWidth + freeSpace) < $menuDesktop.offset().left;

        if(!desktopMode) {
            $body.toggleClass('u-body--desktop-menu-mode', false);
            $body.toggleClass('u-body--mobile-menu-mode', true);
        }

        $menuDesktop.css({ 
            'position': '',
            'top': '',
            'right': ''
        });
    }

    function startHeader() {
        resizeMenu();

        window.addEventListener('resize', resizeMenu);

        // animation
        $header.addClass('is-animation-running');
        $header.removeClass('is-not-initialized');
        // burger icon
        anime.timeline({
                easing: 'linear',
                complete: function () {
                    $header.removeClass('is-animation-running');
                }
            })

            // headline
            .add({
                targets: '.u-teaser__headline',
                duration: 333,
                //offset: '-=567',
                translateY: ["100%", 0],
                opacity: [0, 1]
            })

            // text
            .add({
                targets: '.u-teaser__text',
                duration: 666,
                offset: '-=300',
                translateY: ["100%", 0],
                opacity: [0, 1],
                lineHeight: ['5em', '1.5em'],
                marginBottom: ['-5em', '1em'],
                complete: function (t, e) {
                    $('.u-teaser__text').css({
                        'line-height': '',
                        'margin-bottom': ''
                    });
                },
            })

            // headline and lang switcher
            .add({
                targets: '.u-header__logo, .u-lang-switcher',
                duration: 333,
                offset: '-=666',
                opacity: [0, 1]
            })

            // controls
            .add({
                targets: '.u-controls',
                duration: 266,
                offset: '-=366',
                opacity: [0, 1]
            })
            .add({
                targets: '.u-main-slider__prev',
                duration: 633,
                offset: '-=366',
                translateX: ["-300%", 0],
                opacity: [0, 1]
            })
            .add({
                targets: '.u-main-slider__next',
                duration: 633,
                offset: '-=633',
                translateX: ["300%", 0],
                opacity: [0, 1]
            })


            // burger
            .add({
                targets: '.u-menu-toggler__icon',
                duration: 366,
                offset: '-=466',
                scaleX: [0, 1],
                begin: function () {
                    $(burgerIconLineSelector).show();
                }
            })
            .add({
                targets: burgerIconLineSelector + '-3',
                duration: 300,
                offset: '-=66',
                width: [0, 26.5],
                x: [31.8, 31.8],
                begin: function () {
                    $(burgerIconLineSelector).show();
                }
            })
            .add({
                targets: burgerIconLineSelector + '-2',
                duration: 300,
                offset: '-=200',
                width: [0, 26.5],
                x: [31.8, 31.8],
            })
            .add({
                targets: burgerIconLineSelector + '-1',
                duration: 300,
                offset: '-=200',
                width: [0, 26.5],
                x: [31.8, 31.8],
            })

            // see more
            .add({
                targets: '.u-header__see-more',
                duration: 233,
                offset: '-=333',
                opacity: [0, 1]
            })
            .add({
                targets: '.u-header__see-more-icon',
                duration: 400,
                offset: '-=200',
                translateY: ["-300%", 0],
                opacity: [0, 1]
            })
            .add({
                targets: '.u-header__see-more-label',
                duration: 400,
                offset: '-=400',
                translateY: ["300%", 0]
            })

            // photographer
            .add({
                targets: '.u-main-slider__photographer',
                duration: 400,
                offset: '-=400',
                opacity: [0, 1]
            });


        // see more button loop animation
        anime.timeline({
            easing: 'linear',
            loop: true
        }).
        add({
            targets: '.u-header__see-more-icon .u-svg-button__arrow',
            delay: 4000,
            duration: 300,
            translateY: ['0%', '15%']
        }).
        add({
            targets: '.u-header__see-more-icon .u-svg-button__arrow',
            duration: 300,
            translateY: ['15%', '0%']
        })
    }

    function openMenu() {
        $header.addClass('is-animation-running');

        anime.timeline({
                easing: 'easeOutExpo',
                complete: function () {
                    $header.removeClass('is-animation-running');
                },
                begin: function () {
                    $('body').addClass('has-open-menu');
                    $('.u-header__social-buttons .u-social-link').css('transform', 'scale(0)');
                    $('.u-header__bottom-menu-link, .u-header__bottom-menu-copyright').css('opacity', 0);
                }
            })

            // hide burger icon
            .add({
                targets: burgerIconLineSelector,
                duration: 333,
                width: [26.5, 0],
                x: [31.8, 31.8 + 26.5],
                complete: function () {
                    $(burgerIconLineSelector).hide();
                }
            })

            // show close icon
            .add({
                targets: closeIconLineSelector + '-1',
                duration: 200,
                width: [0, 25.1],
                x: [32.5, 32.5],
                begin: function () {
                    $(closeIconLineSelector).show();
                }
            })
            .add({
                targets: closeIconLineSelector + '-2',
                duration: 200,
                width: [0, 25.1],
                x: [32.5, 32.5]
            })

            // open menu container
            .add({
                targets: mainMenuSelector,
                duration: 733,
                offset: '-=400',
                width: [0, '100%'],
                begin: function () {
                    $mainMenu.show();
                }
            })

            .add({
                targets: '.u-main-menu__link',
                duration: 1,
                opacity: [0, 0],
                translateX: ['-10vw', '-10vw']
            })
            .add({
                duration: 1,
                complete: function () {
                    var $menuItems = $('.u-main-menu__list-item');
                    for (var i = 0; i < $menuItems.length; i++) {
                        animateMenuItemOpen($menuItems.eq(i), i * 200);
                    }
                }
            })
            .add({
                targets: '.u-header__social-button-text',
                duration: 166,
                opacity: [0, 1],
                begin: function () {
                    var $socialLinks = $('.u-header__social-buttons .u-social-link');
                    for (var i = 0; i < $socialLinks.length; i++) {
                        animateSocialIconOpen($socialLinks.eq(i), i * 166);
                    }
                }
            })
            .add({
                offset: '-=700',
                begin: function () {
                    var $bottomMenuItems = $('.u-header__bottom-menu-link, .u-header__bottom-menu-copyright');
                    for (var i = 0; i < $bottomMenuItems.length; i++) {
                        animateBottomMenuLinkOpen($bottomMenuItems.eq(i), i * 66);
                    }
                }
            })

        ;
    }

    function animateMenuItemOpen(menuItem, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(menuItem).find('.u-main-menu__link')[0],
                duration: 300,
                offset: '-=166',
                opacity: [0, 1],
                translateX: ['-10vw', '0vw']
            })
    }

    function animateSocialIconOpen(socialIcon, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(socialIcon)[0],
                duration: 166,
                delay: delay,
                scale: [0, 1]
            })
    }

    function animateBottomMenuLinkOpen(link, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(link)[0],
                duration: 333,
                delay: delay,
                opacity: [0, 1]
            })
    }


    function animateMenuItemClose(menuItem, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(menuItem).find('.u-main-menu__link')[0],
                duration: 300,
                offset: '-=166',
                opacity: [1, 0],
                translateX: ['0vw', '-10vw']
            })
    }

    function animateBottomMenuLinkClose(link, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(link)[0],
                duration: 333,
                delay: delay,
                opacity: [1, 0]
            })
    }

    function animateSocialIconClose(socialIcon, delay) {
        anime.timeline({
                easing: 'linear'
            })
            .add({
                targets: $(socialIcon)[0],
                duration: 166,
                delay: delay,
                scale: [1, 0]
            })
    }

    function closeMenu() {
        $header.addClass('is-animation-running');
        anime.timeline({
                easing: 'easeOutExpo',
                complete: function () {
                    $header.removeClass('is-animation-running');
                },
                begin: function () {
                    $('body').removeClass('has-open-menu');
                    $('.u-header__social-buttons, .u-header__bottom-menu').css('display', 'flex');
                }
            })

            .add({
                duration: 1,
                complete: function () {
                    var $menuItems = $('.u-main-menu__list-item');
                    for (var i = 0; i < $menuItems.length; i++) {
                        animateMenuItemClose($menuItems.eq(i), i * 200);
                    }
                }
            })

            // bottom menu links
            .add({
                // offset: '-=200',
                duration: 1,
                begin: function () {
                    var $bottomMenuItems = $('.u-header__bottom-menu-link, .u-header__bottom-menu-copyright').get().reverse();
                    for (var i = 0; i < $bottomMenuItems.length; i++) {
                        animateBottomMenuLinkClose($bottomMenuItems[i], i * 66);
                    }
                }
            })

            // social icons
            .add({
                // offset: '-=133',
                duration: 1,
                begin: function () {
                    var $socialLinks = $('.u-header__social-buttons .u-social-link').get().reverse();
                    for (var i = 0; i < $socialLinks.length; i++) {
                        animateSocialIconClose($socialLinks[i], i * 166);
                    }
                }
            })

            // close menu container
            .add({
                targets: mainMenuSelector,
                duration: 866,
                delay: 666,
                width: ['100%', 0]
            })

            // switch close icon to burger icon
            .add({
                targets: closeIconLineSelector + '-2',
                duration: 200,
                offset: '-=866',
                width: [25.1, 0],
                x: [32.5, 32.5 + 25.1],
            })
            .add({
                targets: closeIconLineSelector + '-1',
                duration: 200,
                width: [25.1, 0],
                x: [32.5, 32.5 + 25.1],
                complete: function () {
                    $(closeIconLineSelector).hide();
                }
            })
            .add({
                targets: burgerIconLineSelector + '-3',
                duration: 266,
                width: [0, 26.5],
                x: [31.8, 31.8],
                begin: function () {
                    $(burgerIconLineSelector).show();
                }
            })
            .add({
                targets: burgerIconLineSelector + '-2',
                duration: 266,
                offset: '-=66',
                width: [0, 26.5],
                x: [31.8, 31.8],
            })
            .add({
                targets: burgerIconLineSelector + '-1',
                duration: 266,
                offset: '-=66',
                width: [0, 26.5],
                x: [31.8, 31.8],
            });
    }


    $(function () {
        startHeader();
    });

    $('.u-menu-toggler').on('click', function () {

        if ($header.hasClass('is-animation-running')) return;


        var newState = !$header.hasClass(openClass);

        $header.toggleClass(openClass, newState);

        if (newState) {
            openMenu();
        } else {
            closeMenu();
        }
    });

    function scrollToCategory(catId, milliseconds) {
        var $element = $('.u-main-content > [data-cat="' + (catId || 1) + '"]');

        if ($element.length === 0) {
            $element = $('.u-main-content');
        }

        if ($element.length > 0) {
            var offTop = $element.offset().top - 50;
            $("html, body").stop().animate({ scrollTop: offTop }, milliseconds || 500, 'swing');
        }
    }

    function scrollToModule(modId) {
        if (modId === false) return;
        var $element = $('.u-main-content > [module-number="' + (modId || 1) + '"]');

        if ($element.length === 0) {
            $element = $('.u-main-content');
        }

        if ($element.length > 0) {
            var offTop = $element.offset().top - 50;
            $("html, body").stop().animate({ scrollTop: offTop }, 500, 'swing');
        }
    }

    $(document).on('click', '.u-header__see-more', function () {
        var link = document.querySelector('.u-main-slider .slick-active .u-main-slider__item-headline');

        if(link) {
            link.click();
        }
    });

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return (false);
    }

    function fitCategorySpacerToMenu() {
        let $categorySpacer = $('.u-header__category-spacer');

        //im element exists
        if($categorySpacer.length) {
            /* //if mobile
            if(window.matchMedia("only screen and (max-width: 984px)").matches) {

                //do nothing, show/hide by css

            } else {
                
            } */

            //just always set width
            $categorySpacer.width($('.u-header__menu-desktop').outerWidth());
        }
    }

    

    $(document).ready(function () {

        setTimeout(function() {
            if(pageJumpedToModuleOnLoad) return;
            pageJumpedToModuleOnLoad = true;
    
            var modId = getQueryVariable('mod');
            if(modId) {
                scrollToModule(modId);
            } else {
                var catId = getQueryVariable('category');
                if(catId) {
                    scrollToCategory(catId, 1);
                }
            }
        }, 300);

        

        $(window).on('resize', fitCategorySpacerToMenu)

        fitCategorySpacerToMenu();
    });

    // function setIntroParallax() {

    //     var windowHeight = $(window).height(),
    //         scrollTop = $(window).scrollTop(),
    //         contentStartOffset = -1 * windowHeight / 2,
    //         scrollOffset = windowHeight - scrollTop;

    //     if(scrollOffset > 1) { // 1px is to fix rounding errors
    //         $('.u-main-content__wrapper').css({
    //             height: $('.u-main-content').outerHeight()
    //         });
    //         $('.u-main-content').css({
    //             transform: 'translateY(' + ((windowHeight + contentStartOffset) * (windowHeight - scrollTop) / windowHeight) + 'px)',
    //             position: 'fixed'
    //         });
    //     } else {
    //         $('.u-main-content__wrapper').css({
    //             height: ''
    //         });
    //         $('.u-main-content').css({
    //             transform: 'translateY(0px)',
    //             position: 'relative'
    //         });
    //     }
    // }

    // setIntroParallax();
    // var activeScrollAnimation = false;
    // $(window).scroll(function () {
    //     if(!activeScrollAnimation) {
    //         activeScrollAnimation = true;

    //         setTimeout(function() {
    //             activeScrollAnimation = false;
    //         });

    //         setIntroParallax();
    
    //         if($('.u-main-slider').hasClass('slick-initialized')) {
    //             $('.u-main-slider').slick('slickPause');
    //         } else {
    //             setTimeout(function() {
    //                 $('.u-main-slider').slick('slickPause');
    //             }, 1000);
    //         }
    //     }
    // });

})();
(function() {

    var durations = {
        buttonOpen: 900,
        imageOpen: 1000
    };

    function Illustration($element, options) {
        this.$element = $element;
        this.$popup = this.$element.find('.u-illustration__popup');
        this.$closeButton = this.$element.find('.u-illustration__popup-close-button');
        this.$popupImage = this.$element.find('.u-illustration__popup-image');
        this.$popupText = this.$element.find('.u-illustration__popup-text');
        this.$kicker = this.$element.find('.u-illustration__kicker');
        this.$separator = this.$element.find('.u-illustration__separator');
        this.$headline = this.$element.find('.u-illustration__headline');
        this.$text = this.$element.find('.u-illustration__text');
        this.$activeButton;
        this.blurEffect = null;
        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    Illustration.prototype.init = function() {

        var that = this;
        
        var $hotspot = this.$element.find('.u-illustration__hotspot').filter(function(index, item) { return $(item).find('.u-illustration__hotspot-icon--bordered').length === 0 });
        if($hotspot.length > 0) {
            that.startButtonBlur($hotspot);
        }

        this.$element.on('click', '.u-illustration__hotspot', function(e) {
            that.$activeButton = $(e.currentTarget);
            that.openPopup($(e.currentTarget));
        });

        // this.$element.on('mouseenter', '.u-illustration__hotspot', function(e) {
        //     that.startButtonBlur(e.currentTarget);
        // });

        // this.$element.on('mouseleave', '.u-illustration__hotspot', function(e) {
        //     that.stopButtonBlur();
        // });

        this.$closeButton.on('click', function(e) {
            that.closePopup(that.$activeButton);
        });

        this.$element.find('.u-illustration__background').click(function(e) {
            var $container = that.$element.find('.u-illustration__background'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        });

        this.$element.generateCustomCursor({
            $container: this.$element.find('.u-illustration__content-wrapper')
        });


    }

    Illustration.prototype.startButtonBlur = function(hotspot) {
        var $hotspot = $(hotspot),
            $backgroundWrapper = this.$element.find('.u-illustration__background'),
            $blurPicture,
            blurClass = 'u-illustration__blur-picture',
            $firstRoundedButton = $hotspot.find('.u-illustration__hotspot-icon--rounded'),
            coords,
            isEdgeBrowser = window.navigator.userAgent.indexOf('Edge/') >= 0,
            isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification)),
            iPhone = navigator.userAgent.indexOf('iPhone') >= 0,
            iPad = navigator.userAgent.indexOf('iPad') >= 0;

        if($firstRoundedButton.length === 0 || isEdgeBrowser || isSafari || iPhone || iPad) return;

        coords = $firstRoundedButton.eq(0).parent()[0].style.left + ' ' + $firstRoundedButton.eq(0).parent()[0].style.top;
        $backgroundWrapper.find('.' + blurClass).remove();
        $blurPicture = $backgroundWrapper.children('.u-picture').clone().addClass(blurClass).appendTo($backgroundWrapper);

        this.blurEffect = anime.timeline({
            easing: 'linear',
            loop: true
        })
        .add({
            targets: $blurPicture[0],
            duration: 366,
            clipPath: ['circle(1.855% at ' + coords + ')', 'circle(8% at ' + coords + ')'],
            opacity: [1,1],
            begin: function(anim) {
                $('.' + blurClass).css({
                    '-webkit-clip-path': 'circle(1.855% at ' + coords + ')'
                });
                $('.' + blurClass).animate({
                    '-webkit-clip-path': 'circle(8% at ' + coords + ')'
                }, 366);
            },
        })
        .add({
            targets: $blurPicture[0],
            duration: 333,
            clipPath: ['circle(8% at ' + coords + ')', 'circle(10% at ' + coords + ')'],
            opacity: [1,0]
        })
        .add({
            targets: $blurPicture[0],
            duration: 1000
        });

        /**
        * 
        *
        *
        */

        // var css = '@keyframes bubble-blur { 0% { -webkit-clip-path: circle(1.855% at ' + coords + '); webkit-clip-path: circle(1.855% at ' + coords + '); opacity: 0; } 1% { opacity: 1; } 22% { -webkit-clip-path: circle(8% at ' + coords + '); webkit-clip-path: circle(8% at ' + coords + '); opacity: 1; } 41% { -webkit-clip-path: circle(10% at ' + coords + '); webkit-clip-path: circle(10% at ' + coords + '); opacity: 0; } 100% { opacity: 0; }} .u-illustration__blur-picture { animation: bubble-blur 1.699s infinite; }',
        //     head = document.head || document.getElementsByTagName('head')[0],
        //     style = document.createElement('style');

        // head.appendChild(style);

        // style.type = 'text/css';
        // style.appendChild(document.createTextNode(css));
    }

    Illustration.prototype.stopButtonBlur = function() {
        this.blurEffect.pause();
        this.blurEffect.seek(0);
    }

    Illustration.prototype.openPopup = function($button) {
        var that = this,
            data = $button.data(),
            $clonedImage;

        if(that.$element.hasClass('is-animation-running')) return;

        that.$element.addClass('is-animation-running');

        if(that.$element.offset().top < $(window).scrollTop()) {
            $("html, body").stop().animate({ scrollTop: that.$element.offset().top }, 500, 'swing');
        }

        that.$popup.show();
        // delete and recreate for IE11 / ofi bugfix
        that.$popupImage.find('img').remove();
        var $img = $('<img src=' + data.image + '/>');
        that.$popupImage.append($img);
        that.$kicker.html(data.kicker);
        if(data.kicker.trim()) {
            that.$kicker.show();
            that.$separator.show();
        } else {
            that.$kicker.hide();
            that.$separator.hide();
        }

        that.$headline.html(data.headline);
        if(data.headline.trim()) {
            that.$headline.show();
        } else {
            that.$headline.hide();
        }
        
        that.$text.html(data.text);
        if(data.text.trim()) {
            that.$text.show();
        } else {
            that.$text.hide();
        }

        $clonedImage = that.$popupImage.clone().addClass('is-moving').insertAfter(that.$popupImage);
        that.$popupImage.css('opacity', 0);
        that.$popupText.addClass('is-moving');
        that.$popup.attr('aria-hidden', 'false');

        // imageTargetPosition

        var popupOffset = that.$popup.offset(),
            popupWidth = that.$popup.outerWidth(),
            popupHeight = that.$popup.outerHeight(),
            imageOffset = that.$popupImage.offset(),
            imageWidth = that.$popupImage.outerWidth(),
            imageHeight = that.$popupImage.outerHeight(),
            
            imageTargetPosition = {
                left: (imageOffset.left - popupOffset.left + imageWidth / 2) * 100 / popupWidth,
                top: (imageOffset.top - popupOffset.top + imageHeight / 2) * 100 / popupHeight
            };

        anime.timeline({
            easing: 'easeOutExpo',
            begin: function(anim) {
                
            },
            complete: function () {
                that.$element.removeClass('is-animation-running');
                that.$element.find('.u-illustration__blur-picture').css('visibility', 'hidden');
            }
        })
        // background
        .add({
            targets: that.$popup[0],
            duration: 600,
            backgroundColor: ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.8)']
        })
        // text
        .add({
            targets: that.$popupText[0],
            duration: 600,
            offset: '-=600',
            opacity: [0, 1]
        })
        // image
        .add({
            targets: $clonedImage[0],
            duration: 600,
            offset: '-=600',
            begin: function(anim) {
            },
            complete: function() {
                $clonedImage.remove();
                that.$popupImage.css('opacity', 1);
            },
            width: [$button.outerWidth(), that.$popupImage.outerWidth()],
            height: [$button.outerHeight(), that.$popupImage.outerHeight()],
            left: [$button[0].style.left, imageTargetPosition.left],
            top: [$button[0].style.top, imageTargetPosition.top],
        })
        // hotspots
        .add({
            targets: that.$element.find('.u-illustration__hotspots')[0],
            offset: '-=600',
            duration: 300,
            opacity: [1, 0]
        })
        // close button bg
        .add({
            targets: that.$closeButton.find('.u-illustration__popup-close-icon-background')[0],
            duration: 600,
            offset: '-=300',
            opacity: [0, 1],
            complete: function() {
                that.$popupText.removeClass('is-moving');
            }
        })
        // separator
        .add({
            targets: that.$separator[0],
            offset: '-=166',
            duration: 333,
            scaleX: [0, 1]
        })
    }

    Illustration.prototype.closePopup = function($button) {
        var that = this,
            $clonedImage;

        if(that.$element.hasClass('is-animation-running')) return;

        that.$element.addClass('is-animation-running');

        $clonedImage = that.$popupImage.clone().addClass('is-moving').insertAfter(that.$popupImage);
        that.$popupImage.css('opacity', 0);
        that.$popup.attr('aria-hidden', 'true');

        // imageTargetPosition

        var popupOffset = that.$popup.offset(),
            popupWidth = that.$popup.outerWidth(),
            popupHeight = that.$popup.outerHeight(),
            imageOffset = that.$popupImage.offset(),
            imageWidth = that.$popupImage.outerWidth(),
            imageHeight = that.$popupImage.outerHeight(),

            imageTargetPosition = {
                left: (imageOffset.left - popupOffset.left + imageWidth / 2) * 100 / popupWidth,
                top: (imageOffset.top - popupOffset.top + imageHeight / 2) * 100 / popupHeight
            };

        anime.timeline({
            easing: 'easeOutExpo',
            begin: function() {
                that.$element.find('.u-illustration__blur-picture').css('visibility', 'visible');
            },
            complete: function(anim) {
                that.$popupText.removeClass('is-moving');
                that.$popup.hide();
                that.$element.removeClass('is-animation-running');
            }
        })
        // separator
        .add({
            targets: that.$separator[0],
            duration: 233,
            scaleX: [1, 0]
        })

        // close button bg
        .add({
            targets: that.$closeButton.find('.u-illustration__popup-close-icon-background')[0],
            duration: 600,
            offset: '-=200',
            opacity: [1, 0]
        })
        // hotspots
        .add({
            targets: that.$element.find('.u-illustration__hotspots')[0],
            duration: 300,
            offset: '-=600',
            opacity: [0, 1]
        })
        // image
        .add({
            targets: $clonedImage[0],
            duration: 600,
            offset: '-=300',
            opacity: [1, 0],
            complete: function() {
                $clonedImage.remove();
                that.$popupImage.css('opacity', 1);
            },
            width: [that.$popupImage.outerWidth(), $button.outerWidth()],
            height: [that.$popupImage.outerHeight(), $button.outerHeight()],
            left: [imageTargetPosition.left, $button[0].style.left],
            top: [imageTargetPosition.top, $button[0].style.top],
        })
        // text
        .add({
            targets: that.$popupText[0],
            duration: 600,
            offset: '-=600',
            opacity: [1, 0]
        })
        // background
        .add({
            targets: that.$popup[0],
            duration: 600,
            offset: '-=600',
            backgroundColor: ['rgba(0, 0, 0, 0.8)', 'rgba(0, 0, 0, 0)']
        })

    }

    $(document).ready(function() {

        $('.u-illustration').each(function(index, element) {
            $element = $(element);
            if(!$element.data('illustration')) {
                var illustrionObject = new Illustration($element);
                $element.data('illustration', illustrionObject);
            }
        });

        var inviewIllustration = inView('.u-illustration').on('enter', function(target) {

            var $target = $(target);

            if($target.hasClass('u-inview-complete')) return;

            // anime.timeline({
            //     easing: 'linear',
            //     duration: 2000,
            //     begin: function() {
            //         $target.addClass('u-inview-complete');
            //     }
            // }).
            // add({
            //     targets: target,
            //     opacity: [0,1],
            // });
        });
        destroyInViewOnContentDestroy(inviewIllustration);
    });

})();
(function () {


    function IllustrationTwoSides($element, options) {
        this.$element = $element;

        this.$leftSide = this.$element.find('.u-illustration-two-sides__content-inner-wrapper-left');
        this.$rightSide = this.$element.find('.u-illustration-two-sides__content-inner-wrapper-right');

        this.$popup = this.$element.find('.u-illustration-two-sides__popup');
        this.$closeButton = this.$element.find('.u-illustration-two-sides__popup-close-button');

        this.$globalMenuTogglerButton = $('.u-header .u-menu-toggler');

        this.$popupImageLeft = this.$leftSide.find('.u-illustration-two-sides__popup-image');
        this.$popupImageRight = this.$rightSide.find('.u-illustration-two-sides__popup-image');

        this.$popupTextRight = this.$rightSide.find('.u-illustration-two-sides__text.u-illustration-two-sides__popup-text');
        this.$popupTextLeft = this.$leftSide.find('.u-illustration-two-sides__text.u-illustration-two-sides__popup-text');

        this.$popupText = this.$element.find('.u-illustration-two-sides__popup-text');
        this.$kicker = this.$element.find('.u-illustration-two-sides__kicker');
        this.$separator = this.$element.find('.u-illustration-two-sides__separator');
        this.$headline = this.$element.find('.u-illustration-two-sides__headline');
        this.$text = this.$element.find('.u-illustration-two-sides__text');
        this.$activeButton;
        this.blurEffect = null;
        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    IllustrationTwoSides.prototype.init = function () {

        var that = this;

        var $hotspot = this.$element.find('.u-illustration-two-sides__hotspot')
            .filter(function (index, item) {
                return $(item).find('.u-illustration-two-sides__hotspot-icon--bordered').length === 0
            });

        /* if($hotspot.length > 0) {
            that.startButtonBlur($hotspot);
        } */

        this.$element.on('click', '.u-illustration-two-sides__hotspot', function (e) {
            console.log("Opening popup...")
            that.$activeButton = $(e.currentTarget);
            that.openPopup($(e.currentTarget));
        });

        // this.$element.on('mouseenter', '.u-illustration-two-sides__hotspot', function(e) {
        //     that.startButtonBlur(e.currentTarget);
        // });

        // this.$element.on('mouseleave', '.u-illustration-two-sides__hotspot', function(e) {
        //     that.stopButtonBlur();
        // });

        this.$closeButton.on('click', function (e) {
            that.closePopup(that.$activeButton);
        });

        // hide or show buttons depending on if element in view
        $(window).on('resize scroll', function() {
            /* console.log(that.$globalMenuTogglerButton); */

            var elementTop = that.$element.offset().top;
            var elementBottom = elementTop + that.$element.outerHeight();
        
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
        
            //if not in viewport
            if(!( elementBottom > viewportTop && elementTop < viewportBottom )){
                that.$closeButton.hide();
                /* that.$globalMenuTogglerButton.show(); */
            } else {
                that.$closeButton.show();
                /* that.$globalMenuTogglerButton.hide(); */
            }
        });

        this.$leftSide.click(function (e) {
            let $container = that.$leftSide.find('.u-illustration-two-sides__background'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Left Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        });
        this.$rightSide.click(function (e) {
            let $container = that.$rightSide.find('.u-illustration-two-sides__background'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Right Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        });

        /* this.$element.generateCustomCursor({
            $container: this.$element.find('.u-illustration-two-sides__content-wrapper')
        }); */


    }


    IllustrationTwoSides.prototype.openPopup = function ($button) {
        var that = this,
            data = $button.data(),
            $clonedImageLeft,
            $clonedImageRight;



        that.$popup.show();


        //replace left img if existing


        if (!(data.imageleft === null || (/^\s*$/).test(data.imageleft))) {
            that.$popupImageLeft.find('img').remove();
            var $img = $('<img src=' + data.imageleft + '/>');
            that.$popupImageLeft.append($img);

            $clonedImageLeft = that.$popupImageLeft.clone().insertAfter(that.$popupImageLeft);
            $clonedImageLeft.remove();
        }

        //replace right img if existing
        if (!(data.imageright === null || (/^\s*$/).test(data.imageright))) {
            that.$popupImageRight.find('img').remove();
            var $imgRight = $('<img src=' + data.imageright + '/>');
            that.$popupImageRight.append($imgRight);

            $clonedImageRight = that.$popupImageRight.clone().insertAfter(that.$popupImageRight);
            $clonedImageRight.remove();
        }


        //replace left text
        that.$popupTextLeft.html(data.textleft);

        //replace right text
        that.$popupTextRight.html(data.textright);


        //jump to top if in mobile
        if(window.matchMedia("only screen and (max-width: 768px)").matches) {
            
        that.$element[0].scrollIntoView();
        }
    }


    IllustrationTwoSides.prototype.closePopup = function ($button) {
        var that = this,
            $clonedImageLeft,
            $clonedImageRight;

        //remove image left
        /* $clonedImageLeft = that.$popupImageLeft.clone().insertAfter(that.$popupImageLeft);
        $clonedImageLeft.remove(); */
        that.$popupImageLeft.html("");

        //remove image right
        /* $clonedImageRight = that.$popupImageRight.clone().insertAfter(that.$popupImageRight);
        $clonedImageRight.remove(); */
        that.$popupImageRight.html("");

        //clear left text
        that.$popupTextLeft.html("");

        //clear right text
        that.$popupTextRight.html("");

        that.$popup.hide();
    }

    $(document).ready(function () {

        $('.u-illustration-two-sides').each(function (index, element) {
            $element = $(element);
            if (!$element.data('illustration-two-sides')) {
                var illustrationTwoSidesObject = new IllustrationTwoSides($element);
                $element.data('illustration-two-sides', illustrationTwoSidesObject);
            }
        });


    });

})();
(function () {


    function illustrationDesktopMobile($element, options) {
        this.$element = $element;

        this.$container = this.$element.find('.u-illustration-desktop-mobile__content-inner-wrapper');
        this.$leftSide = this.$element.find('.u-illustration-desktop-mobile__content-inner-wrapper-left');
        this.$rightSide = this.$element.find('.u-illustration-desktop-mobile__content-inner-wrapper-right');

        this.$popup = this.$element.find('.u-illustration-desktop-mobile__popup');
        this.$closeButton = this.$element.find('.u-illustration-desktop-mobile__popup-close-button');
        this.$popupImageLeft = this.$leftSide.find('.u-illustration-desktop-mobile__popup-image');
        this.$popupImageRight = this.$rightSide.find('.u-illustration-desktop-mobile__popup-image');

        this.$popupTextDesktop = this.$element.find('.u-illustration-desktop-mobile__popup-desktop .u-illustration-desktop-mobile__text.u-illustration-desktop-mobile__popup-text');
        this.$popupTextMobile = this.$element.find('.u-illustration-desktop-mobile__popup-mobile .u-illustration-desktop-mobile__text.u-illustration-desktop-mobile__popup-text');

        this.$popupText = this.$element.find('.u-illustration-desktop-mobile__popup-text');
        this.$kicker = this.$element.find('.u-illustration-desktop-mobile__kicker');
        this.$separator = this.$element.find('.u-illustration-desktop-mobile__separator');
        this.$headline = this.$element.find('.u-illustration-desktop-mobile__headline');
        this.$text = this.$element.find('.u-illustration-desktop-mobile__text');
        this.$activeButton;
        this.blurEffect = null;
        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    illustrationDesktopMobile.prototype.init = function () {

        var that = this;

        var $hotspot = this.$element.find('.u-illustration-desktop-mobile__hotspot')
            .filter(function (index, item) {
                return $(item).find('.u-illustration-desktop-mobile__hotspot-icon--bordered').length === 0
            });

        /* if($hotspot.length > 0) {
            that.startButtonBlur($hotspot);
        } */

        this.$element.on('click', '.u-illustration-desktop-mobile__hotspot', function (e) {
            console.log("Opening popup...")
            that.$activeButton = $(e.currentTarget);
            that.openPopup($(e.currentTarget));
        });

        // this.$element.on('mouseenter', '.u-illustration-desktop-mobile__hotspot', function(e) {
        //     that.startButtonBlur(e.currentTarget);
        // });

        // this.$element.on('mouseleave', '.u-illustration-desktop-mobile__hotspot', function(e) {
        //     that.stopButtonBlur();
        // });

        this.$closeButton.on('click', function (e) {
            that.closePopup(that.$activeButton);
        });


        this.$container.click(function (e) {
            let $container = that.$container.find('.u-illustration-desktop-mobile__background-desktop'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Desktop Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));


            let $containerMobile = that.$container.find('.u-illustration-desktop-mobile__background-mobile');

                parentOffset = $containerMobile.offset();
                relX = e.pageX - parentOffset.left;
                relY = e.pageY - parentOffset.top;
                percentageX = relX * 100 / $containerMobile.width();
                percentageY = relY * 100 / $containerMobile.height();

            console.info('Mobile Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        });
        /* this.$leftSide.click(function (e) {
            let $container = that.$leftSide.find('.u-illustration-desktop-mobile__background'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Left Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        });
        this.$rightSide.click(function (e) {
            let $container = that.$rightSide.find('.u-illustration-desktop-mobile__background'),
                parentOffset = $container.offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top,
                percentageX = relX * 100 / $container.width(),
                percentageY = relY * 100 / $container.height();

            console.info('Right Image Hotspot Position:  T ' + (Math.round(percentageY * 100) / 100) + '  -   L ' + (Math.round(percentageX * 100) / 100));
        }); */

        /* this.$element.generateCustomCursor({
            $container: this.$element.find('.u-illustration-desktop-mobile__content-wrapper')
        }); */


    }


    illustrationDesktopMobile.prototype.openPopup = function ($button) {
        var that = this,
            data = $button.data(),
            $clonedImageLeft,
            $clonedImageRight;



        that.$popup.show();


        //replace left img if existing


        if (!(data.imageleft === null || (/^\s*$/).test(data.imageleft))) {
            that.$popupImageLeft.find('img').remove();
            var $img = $('<img src=' + data.imageleft + '/>');
            that.$popupImageLeft.append($img);

            $clonedImageLeft = that.$popupImageLeft.clone().insertAfter(that.$popupImageLeft);
            $clonedImageLeft.remove();
        }

        //replace right img if existing
        if (!(data.imageright === null || (/^\s*$/).test(data.imageright))) {
            that.$popupImageRight.find('img').remove();
            var $imgRight = $('<img src=' + data.imageright + '/>');
            that.$popupImageRight.append($imgRight);

            $clonedImageRight = that.$popupImageRight.clone().insertAfter(that.$popupImageRight);
            $clonedImageRight.remove();
        }


        //replace left text
        that.$popupTextMobile.html(data.text);

        //replace right text
        that.$popupTextDesktop.html(data.text);

    }


    illustrationDesktopMobile.prototype.closePopup = function ($button) {
        var that = this,
            $clonedImageLeft,
            $clonedImageRight;

        //remove image left
        /* $clonedImageLeft = that.$popupImageLeft.clone().insertAfter(that.$popupImageLeft);
        $clonedImageLeft.remove(); */
        that.$popupImageLeft.html("");

        //remove image right
        /* $clonedImageRight = that.$popupImageRight.clone().insertAfter(that.$popupImageRight);
        $clonedImageRight.remove(); */
        that.$popupImageRight.html("");

        //clear left text
        that.$popupTextMobile.html("");

        //clear right text
        that.$popupTextDesktop.html("");

        that.$popup.hide();
    }

    function isOnIphoneSafari() {
        var ua = window.navigator.userAgent;
        var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        var webkit = !!ua.match(/WebKit/i);
        var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    
        return iOSSafari;
      }

    

    $(document).ready(function () {

        $('.u-illustration-desktop-mobile').each(function (index, element) {
            $element = $(element);
            if (!$element.data('illustration-desktop-mobile')) {
                var illustrationDesktopMobileObject = new illustrationDesktopMobile($element);
                $element.data('illustration-desktop-mobile', illustrationDesktopMobileObject);
            }
        });



    });

    document.addEventListener("DOMContentLoaded", function() {

        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
        //fix safari Bugs
        if(isSafari){
            console.log("Safari desktop or mobile detected");

            $('.u-illustration-desktop-mobile .u-illustration-desktop-mobile__hotspot-icon text').attr({y: '20'});
        }

        //fix iPhone Safari Bugs
        if(isOnIphoneSafari()){
          console.log("iPhone Safari detected");
    
        }

        //fix IE bugs
        if (window.document.documentMode) {
            // Do IE stuff
            console.log("Using IE");

            $('.u-illustration-desktop-mobile .u-illustration-desktop-mobile__hotspot-icon text').attr({x: '22'});
        }
      });

})();
(function () {

  function ImageSlider(element, options) {
      this.$element = $(element);
      this.slick = null;
      this.sliderOptions = $.extend({}, {
        infinite: false,
        arrows: true,
        autoplay: false,
        adaptiveHeight: false,
        variableWidth: true,
        centerMode: true,
        centerPadding: '40px',
        prevArrow: `<button class="u-image-slider__prev u-svg-button" title="${getTranslation('previous')}" aria-label="${getTranslation('previous')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><circle class="u-svg-button__background" cx="31" cy="31" r="30" /><path class="u-svg-button__border" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5	C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M35,37.2L33.3,39L26,31.5l7.3-7.5l1.7,1.8l-5.6,5.7L35,37.2z" /></svg></button>`,
        nextArrow: `<button class="u-image-slider__next u-svg-button" title="${getTranslation('next')}" aria-label="${getTranslation('next')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><circle class="u-svg-button__background" cx="31" cy="31" r="30"/><path class="u-svg-button__border" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5	C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M27,37.2l1.7,1.8l7.3-7.5L28.7,24L27,25.8l5.6,5.7L27,37.2z"/></svg></button>`
      }, options);

      this.init();
  }

  ImageSlider.prototype.init = function () {
    var that = this;

    this.slick = this.$element.slick(this.sliderOptions)
      .on("setPosition", function (event, slick) {

        // fix empty space after

        // var $lastSlide = slick.$slides.last(),
        //     childPos = $lastSlide.offset(),
        //     parentPos = $lastSlide.parent().offset(),
        //     sliderWidth = slick.$slideTrack.parent().width(),
        //     trackTransform = parseInt(slick.$slideTrack.css("transform").split(",")[4], 10),
        //     childOffset = {
        //         top: childPos.top - parentPos.top,
        //         left: childPos.left - parentPos.left
        //     },
        //     minValue = sliderWidth - childOffset.left - $lastSlide.width() + 0;

        // if (trackTransform < minValue) {
        //   slick.$slideTrack.css({
        //     "transform": "translate3d(" + minValue +"px, 0, 0)",
        //     "transition": "transform .5s"
        //   });
        //   slick.currentSlide = slick.currentSlide - 1;
        // }
      })
      .on('wheel', (function(e) {
        if ( e.originalEvent.deltaX !== 0 ) {
            e.preventDefault();
            if (e.originalEvent.deltaX >= 10) {
              $(this).slick('slickNext');
            } 
            if (e.originalEvent.deltaX <= -10) {
              $(this).slick('slickPrev');
            }
        }
      }));

    this.$element.on('click', '.u-image-slider__item', function(e) {
      var $sliderItem = $(e.target).closest('.u-image-slider__item');
      that.goTo($sliderItem);
    });

    this.$element.data('slider', this);
  }

  ImageSlider.prototype.goTo = function(sliderItem) {
    var $sliderItem = $(sliderItem);

    if($sliderItem.offset().left < 0 || ($(window).width() - $sliderItem.offset().left - $sliderItem.outerWidth()) < 0) {
      this.$element.slick('slickGoTo', $sliderItem.closest('.slick-slide').index());
    }
  }

  $(document).ready(function() {

    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
    document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
    $(window).resize(function() {
      setTimeout(function() {
        document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
      })
    });

      $('.u-image-slider').each(function() {
        new ImageSlider(this);
      })
  });

})();
(function () {

  function InfoTeaserSlider(element) {
      this.$element = $(element);
      this.options = JSON.parse(element.dataset.slick);
      this.slick = null;
      this.sliderOptions = $.extend({
        infinite: true,
        arrows: true,
        autoplay: true,
        pauseOnHover: $(window).width() > 768 ? true : false,
        pauseOnFocus: $(window).width() > 768 ? true : false,
        autoplaySpeed: 4000,
        adaptiveHeight: false,
        variableWidth: false,
        centerMode: false,
        prevArrow: `<button class="u-info-teaser-slider__prev u-svg-button u-svg-button--style-bordered" title="${getTranslation('previous')}" aria-label="${getTranslation('previous')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><path class="u-svg-button__background" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5 C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M35,37.2L33.3,39L26,31.5l7.3-7.5l1.7,1.8l-5.6,5.7L35,37.2z"/></svg></button>`,
        nextArrow: `<button class="u-info-teaser-slider__next u-svg-button" title="${getTranslation('next')}" aria-label="${getTranslation('next')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><circle class="u-svg-button__background" cx="31" cy="31" r="30"/><path class="u-svg-button__border" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5	C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M27,37.2l1.7,1.8l7.3-7.5L28.7,24L27,25.8l5.6,5.7L27,37.2z"/></svg></button>`
      }, this.options);

      this.init();
  }

  InfoTeaserSlider.prototype.init = function () {
    var that = this;

    this.slick = this.$element.slick(this.sliderOptions)
      .on("setPosition", function (event, slick) {

        // fix empty space after

        // var $lastSlide = slick.$slides.last(),
        //     childPos = $lastSlide.offset(),
        //     parentPos = $lastSlide.parent().offset(),
        //     sliderWidth = slick.$slideTrack.parent().width(),
        //     trackTransform = parseInt(slick.$slideTrack.css("transform").split(",")[4], 10),
        //     childOffset = {
        //         top: childPos.top - parentPos.top,
        //         left: childPos.left - parentPos.left
        //     },
        //     minValue = sliderWidth - childOffset.left - $lastSlide.width() + 0;

        // if (trackTransform < minValue) {
        //   slick.$slideTrack.css({
        //     "transform": "translate3d(" + minValue +"px, 0, 0)",
        //     "transition": "transform .5s"
        //   });
        //   slick.currentSlide = slick.currentSlide - 1;
        // }
      })
      .on('wheel', (function(e) {
        if ( e.originalEvent.deltaX !== 0 ) {
            e.preventDefault();
            if (e.originalEvent.deltaX >= 10) {
              $(this).slick('slickNext');
            } 
            if (e.originalEvent.deltaX <= -10) {
              $(this).slick('slickPrev');
            }
        }
      }));

    this.$element.on('click', '.u-info-teaser__item', function(e) {
      var $sliderItem = $(e.target).closest('.u-info-teaser__item');
      that.goTo($sliderItem);
    });

    this.$element.data('slider', this);
  }

  InfoTeaserSlider.prototype.goTo = function(sliderItem) {
    var $sliderItem = $(sliderItem);

    if($sliderItem.offset().left < 0 || ($(window).width() - $sliderItem.offset().left - $sliderItem.outerWidth()) < 0) {
      this.$element.slick('slickGoTo', $sliderItem.closest('.slick-slide').index());
    }
  }

  $(document).ready(function() {

    // document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");
    // document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
    // $(window).resize(function() {
    //   setTimeout(function() {
    //     document.documentElement.style.setProperty('--admin-bar-height', $('html').css('margin-top'));
    //   })
    // });

      $('.u-info-teaser-slider').each(function() {
        new InfoTeaserSlider(this);
      })
  });

})();
(function () {
  function MainSlider(element, options) {
      this.$element = $(element);
      this.slick = null;
      this.sliderOptions = $.extend({}, {
        infinite: true,
        arrows: true,
        autoplay: false,
        pauseOnHover: $(window).width() > 768 ? true : false,
        pauseOnFocus: $(window).width() > 768 ? true : false,
        autoplaySpeed: 4000,
        appendArrows: '.u-controls',
        prevArrow: `<button class="u-main-slider__prev u-svg-button u-svg-button--style-bordered" title="${getTranslation('previous')}" aria-label="${getTranslation('previous')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><path class="u-svg-button__background" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5 C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M35,37.2L33.3,39L26,31.5l7.3-7.5l1.7,1.8l-5.6,5.7L35,37.2z"/></svg></button>`,
        nextArrow: `<button class="u-main-slider__next u-svg-button" title="${getTranslation('next')}" aria-label="${getTranslation('next')}"><svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 62 62" style="enable-background:new 0 0 62 62;" xml:space="preserve"><circle class="u-svg-button__background" cx="31" cy="31" r="30"/><path class="u-svg-button__border" d="M31,61.5C14.2,61.5,0.5,47.8,0.5,31C0.5,14.2,14.2,0.5,31,0.5c16.8,0,30.5,13.7,30.5,30.5	C61.5,47.8,47.8,61.5,31,61.5z M31,1.5C14.7,1.5,1.5,14.7,1.5,31S14.7,60.5,31,60.5S60.5,47.3,60.5,31S47.3,1.5,31,1.5z"/><path class="u-svg-button__arrow" d="M27,37.2l1.7,1.8l7.3-7.5L28.7,24L27,25.8l5.6,5.7L27,37.2z"/></svg></button>`
      }, options);

      this.init();
  }

  MainSlider.prototype.init = function () {

    this.slick = this.$element.slick(this.sliderOptions)
      .on('wheel', (function(e) {
        if ( e.originalEvent.deltaX !== 0 ) {
            e.preventDefault();
            if (e.originalEvent.deltaX >= 10) {
              $(this).slick('slickNext');
            } 
            if (e.originalEvent.deltaX <= -10) {
              $(this).slick('slickPrev');
            }
        }
      }));

    this.$element.data('slider', this);
  }

  function handleButtonsBottom() {
    if(window.matchMedia("only screen and (max-width: 767px)").matches) {

      //adjust height of buttons to copyright
      const subline = $('.u-main-slider__image .u-picture__subline');
      const sublineOffset = subline.length ? subline.offset().top : 0;
      const bottomValue = $('.u-main-slider.u-module--main-slider').outerHeight() - sublineOffset + 10;

      $('.u-controls__wrapper').css("bottom", (bottomValue) + "px");
      $('.u-header__see-more.u-svg-button').css("bottom", bottomValue + "px");
    }
  }

  function isOnIphoneSafari() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

    return iOSSafari;
  }

  $(document).ready(function() {
      $('.u-main-slider').each(function() {
        new MainSlider(this);
      });

      $(window).on('resize', handleButtonsBottom)

      handleButtonsBottom();
  });
})();

(function () {
    function refreshViewportVariable() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    refreshViewportVariable();

    window.addEventListener('resize', () => {
        refreshViewportVariable();
    });
})();

(function () {

    function Panorama(element, options) {
        this.$element = $(element);
        this.$imageWrapper = this.$element.find(".u-panorama__image-wrapper");
        this.viewer = null;

        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    Panorama.prototype.init = function () {

        var that = this;

        if ($('.u-header').hasClass('is-animation-running')) {
            setTimeout(function () {
                that.init();
            }, 100);
            return;
        }

        var container = this.$element.find('.u-panorama__image')[0],
            src = this.$element.data('src'),
            longitude = this.$element.data('longitude'),
            latitude = this.$element.data('latitude'),
            zoom = this.$element.data('zoom');

        this.viewer = new PhotoSphereViewer({
            container: container,
            panorama: src,
            default_fov: zoom || 60,
            default_long: longitude || 0,
            default_lat: latitude || 0,
            navbar: 'gyroscope',
            anim_speed: '0.5rpm',
            time_anim: false,
            touchmove_two_fingers: true,
            onready: function () {
                PSV.toggleDeviceOrientation();
            }
        });

        this.$element.generateCustomCursor({
            $container: this.$element.find('.u-panorama__image-wrapper'),
            forceGrabbing: true
        });
    }

    $(document).ready(function () {

        $('.u-panorama').each(function (index, element) {
            $element = $(element);
            if (!$element.data('panorama')) {
                var panoramaObject = new Panorama($element);
                $element.data('panorama', panoramaObject);
            }
        });

    });

})();
(function() {

    var durations = {
        buttonOpen: 900,
        imageOpen: 1000
    };

    function ReadMore($element, options) {
        this.$element = $element;
        this.$topToolbar = this.$element.find('.u-read-more__top-toolbar');
        this.$bottomToolbar = this.$element.find('.u-read-more__bottom-toolbar');
        this.$readMoreButton = this.$element.find('.u-read-more__read-more-button');
        this.$readLessButton = this.$element.find('.u-read-more__read-less-button');
        this.$modules = this.$element.find('.u-read-more__modules');
        this.isOpen = false;
        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    ReadMore.prototype.init = function() {
        var that = this;

        this.$readMoreButton.click(function(e) {
            that.isOpen = true;
            that.open();
        });

        this.$readLessButton.click(function(e) {
            that.isOpen = true;
            that.close();
        });
    }

    ReadMore.prototype.open = function() {
        this.$topToolbar.hide();
        this.$bottomToolbar.show();
        this.$modules.show();
    }

    ReadMore.prototype.close = function() {
        var lessButtonViewportOffset, moreButtonPageOffset;
        lessButtonViewportOffset = this.$readLessButton[0].getBoundingClientRect().top;
        this.$topToolbar.show();
        this.$bottomToolbar.hide();
        this.$modules.hide();
        moreButtonPageOffset = this.$readMoreButton.offset().top;
        window.scrollTo(0, moreButtonPageOffset - lessButtonViewportOffset);
    }

    $(document).ready(function() {
        $('.u-module--read-more-content').each(function(index, element) {
            $element = $(element);
            if(!$element.data('read-more')) {
                var readMoreObject = new ReadMore($element);
                $element.data('read-more', readMoreObject);
            }
        });
    });

})();

(function () {

    
    function initTicker() {
        var $ticker = $('.u-ticker__wrapper');

        $ticker.each(function(index, item) {
            $(item).marquee({
                //speed in milliseconds of the marquee
                speed: $(window).width() > 768 ? 100 : 50,
                //gap in pixels between the tickers
                gap: 0,
                //time in milliseconds before the marquee will start animating
                delayBeforeStart: 0,
                //'left' or 'right'
                direction: 'left',
                //true or false - should the marquee be duplicated to show an effect of continues flow
                duplicated: 4,
                pauseOnHover: $(window).width() > 768 ? true : false,
                startVisible: true,
            });

            $('.u-ticker__wrapper a').click(function() {
                var mq = $(this).parent('.u-ticker__wrapper').marquee();
                mq.marquee('play');
            });
        })
    }

    $(function () {
        initTicker();
    });

})();
(function () {

    function YoutubePlayer(element, options) {
        this.$element = $(element);
        this.playerId = this.$element.find('iframe').attr('id');
        this.player = null;

        this.options = $.extend({}, {

        }, options);

        this.init();
    }

    YoutubePlayer.prototype.init = function () {
        var that = this;

        this.player = new YT.Player(this.playerId, {});
    }

    $(document).ready(function () {

        $('.u-youtube-player').each(function (index, element) {
            var $element = $(element);
            if (!$element.data('youtube')) {
                var $iframe = $element.find('iframe');
                $iframe.on('load', function() {
                    var playerObject = new YoutubePlayer($element);
                    $element.data('youtube', playerObject);
                });
            }
        });

        var inviewYoutubePlayer = inView('.u-youtube-player').on('enter', function(target) {
            var $target = $(target),
                playerObject = $target.data('youtube');

            if(playerObject && playerObject.player && playerObject.player.playVideo) {
                playerObject.player.playVideo()
            }
        }).on('exit', function(target) {
            var $target = $(target),
                playerObject = $target.data('youtube');

            if(playerObject && playerObject.player && playerObject.player.pauseVideo && playerObject.player.isMuted()) {
                playerObject.player.pauseVideo()
            }
        });
        destroyInViewOnContentDestroy(inviewYoutubePlayer);

    });

})();